module.exports = __webpack_public_path__ + "assets/images/piramide-atividades.568d17e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kit-plans/piramide-atividades.png
// module id = 789
// module chunks = 1